export const masterFirebaseConfig = {
  apiKey: "AIzaSyADw1x8CxqdXmXWgKPWkH4jBl1e6Pi_k8c",
  authDomain: "monopoly-4bd44.firebaseapp.com",
  databaseURL: "https://monopoly-4bd44.firebaseio.com",
  projectId: "monopoly-4bd44",
  storageBucket: "",
  messagingSenderId: "744914506306"
};



// WEBPACK FOOTER //
// /Users/philipeskins/Desktop/Epicodus/monopoly/src/app/api-keys.ts